import RemoteCall from "../../util/RemoteCall";

const remoteCall = new RemoteCall("/api/noAuth/sso");

const loginAsync = (params) => {
    return remoteCall.invoke("login", params);
};

const numasLoginAsync = (params) => {
    return remoteCall.invoke("numasLogin", params);
};

export default {
    loginAsync,
    numasLoginAsync,
};
